import type { VoiceNoteResult } from './types'
import { apiUpload } from './httpClient'

export function uploadVoiceHttp(
  tripId: string,
  blob: Blob,
  pointId: string | null,
  clientId?: string,
): Promise<VoiceNoteResult> {
  const ext = blob.type.includes('mp4') ? 'mp4' : blob.type.includes('ogg') ? 'ogg' : 'webm'
  const fd = new FormData()
  fd.append('file', blob, `voice-note.${ext}`)
  if (pointId) fd.append('point_id', pointId)
  if (clientId) fd.append('client_id', clientId)
  return apiUpload<VoiceNoteResult>(`/trips/${tripId}/voice`, fd)
}
